import * as React from 'react'
import { FormTypes } from '@oneblink/types'

import { sendGoogleAnalyticsEvent } from '@oneblink/apps-react/dist/utils/sendGoogleAnalyticsEvent'

export default function useGoogleAnalyticsFormBeforeUnload({
  form,
  isSubmitting,
}: {
  form?: FormTypes.Form
  isSubmitting?: boolean
}) {
  return React.useCallback(
    ({
      lastElementUpdated,
      submissionDuration,
    }: {
      lastElementUpdated: FormTypes.FormElement | undefined
      submissionDuration: number | undefined
    }) => {
      if (!form || isSubmitting) {
        return
      }

      sendGoogleAnalyticsEvent('oneblink_form_abandon', {
        formId: form.id,
        formName: form.name,
        transport_type: 'beacon',
        lastElementUpdated,
        submissionDuration,
      })
    },
    [form, isSubmitting],
  )
}
